import { render, staticRenderFns } from "./CardLink.vue?vue&type=template&id=3ebfb008&scoped=true"
import script from "./CardLink.vue?vue&type=script&lang=js"
export * from "./CardLink.vue?vue&type=script&lang=js"
import style0 from "./CardLink.vue?vue&type=style&index=0&id=3ebfb008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebfb008",
  null
  
)

export default component.exports